import {gql} from '@apollo/client';

export const CREATE_LEAVE_REQUEST = gql`
  mutation CreateLeaveRequest($leaveRequest: LeaveRequestCreateInput!) {
    createLeaveRequest(leaveRequest: $leaveRequest) {
      id
      assignationType
      typeOfLeave {
        id
      }
      startDate
      endDate
      approvals {
        approvalId
        approvalRole
        approvalStatus
        order
      }
      createdAt
      daysOff
      evidences {
        evidenceType
        url
      }
      status
      userId
      userName
    }
  }
`;

export const ATTACH_EVIDENCE = gql`
  mutation AttachEvidence(
    $leaveRequestId: String!
    $evidenceType: String!
    $imageValue: String!
    $filename: String!
  ) {
    attachEvidence(
      leave_request_id: $leaveRequestId
      evidence_type: $evidenceType
      image_value: $imageValue
      filename: $filename
    ) {
      evidenceType
      url
    }
  }
`;

export const UPLOAD_IMAGE_TO_BUCKET = gql`
  mutation UploadImageToBucket(
    $fileName: String!
    $imageValue: String!
    $bucketPath: String!
  ) {
    uploadImageToBucket(
      fileName: $fileName
      imageValue: $imageValue
      bucketPath: $bucketPath
    ) {
      bucketName
      fileName
      bucketPath
      objectKey
    }
  }
`;

export const UPDATE_LEAVE_REQUEST_DRAFT = gql`
  mutation UpdateLeaveRequestDraft(
    $leaveRequest: LeaveRequestUpdateDraftInput!
  ) {
    updateLeaveRequestDraft(leaveRequest: $leaveRequest) {
      id
    }
  }
`;

export const UPDATE_LEAVE_REQUEST = gql`
  mutation UpdateLeaveRequest($leaveRequest: LeaveRequestUpdateDraftInput!) {
    updateLeaveRequest(leaveRequest: $leaveRequest) {
      id
    }
  }
`;

export const CREATE_COUNTRY_CONFIGURATION = gql`
  mutation CreateCountryConfiguration($countryCode: String!) {
    createCountryConfiguration(countryCode: $countryCode) {
      id
    }
  }
`;

export const UPDATE_LEAVE_REQUEST_STATUS = gql`
  mutation UpdateLeaveRequestStatus(
    $leaveRequest: LeaveRequestUpdateStatusInput!
  ) {
    updateLeaveRequestStatus(leaveRequest: $leaveRequest) {
      id
    }
  }
`;

export const UPDATE_APPROVAL_STATUS = gql`
  mutation UpdateApprovalStatus(
    $approvalId: String!
    $leaveRequestId: String!
    $status: ApprovalStatus!
    $comment: String
  ) {
    updateApprovalStatus(
      approvalId: $approvalId
      leaveRequestId: $leaveRequestId
      status: $status
      comment: $comment
    ) {
      id
    }
  }
`;

export const CREATE_ADDITIONAL_LEAVE = gql`
  mutation CreateAdditionalLeave(
    $userId: String!
    $type: String!
    $initialDate: String!
    $expirationDate: String!
    $days: Float!
    $description: String!
  ) {
    createAdditionalLeave(
      userId: $userId
      type: $type
      initialDate: $initialDate
      expirationDate: $expirationDate
      days: $days
      description: $description
    ) {
      id
    }
  }
`;

export const CREATE_ADDITIONAL_LEAVE_BATCH = gql`
  mutation CreateAdditionalLeaveBatch(
    $targetMode: AdditionalLeaveTargetMode!
    $userIds: [String!]
    $countryCode: String
    $type: String!
    $initialDate: String!
    $expirationDate: String!
    $days: Float!
    $description: String!
  ) {
    createAdditionalLeaveBatch(
      targetMode: $targetMode
      userIds: $userIds
      countryCode: $countryCode
      type: $type
      initialDate: $initialDate
      expirationDate: $expirationDate
      days: $days
      description: $description
    ) {
      createdCount
      affectedUserIds
      errors {
        userId
        errorMessage
      }
    }
  }
`;

export const DELETE_ADDITIONAL_LEAVE = gql`
  mutation DeleteAdditionalLeave(
    $userId: String!
    $additionalLeaveId: String!
  ) {
    deleteAdditionalLeave(
      userId: $userId
      additionalLeaveId: $additionalLeaveId
    )
  }
`;

export const CANCEL_APPROVED_LEAVE_REQUEST = gql`
  mutation CancelApproval(
    $cancelApprovalRequest: LeaveRequestCancelApprovalInput!
  ) {
    cancelApproval(cancelApprovalRequest: $cancelApprovalRequest) {
      id
    }
  }
`;

export const CANCEL_OWN_APPROVED_LEAVE_REQUEST = gql`
  mutation CancelOwnApprovedLeaveRequest($input: LeaveRequestCancelOwnInput!) {
    cancelOwnApprovedLeaveRequest(input: $input) {
      id
    }
  }
`;

export const DISABLE_COUNTRY = gql`
  mutation DisableCountry($countryCode: String!, $reason: String!) {
    disableCountry(countryCode: $countryCode, reason: $reason) {
      id
      country
      status
      disabledAt
      disabledBy
      disabledReason
      affectedUsersCount
      historyId
    }
  }
`;

export const ENABLE_COUNTRY = gql`
  mutation EnableCountry($countryCode: String!, $reason: String!) {
    enableCountry(countryCode: $countryCode, reason: $reason) {
      id
      country
      status
      isActive
    }
  }
`;

export const APPLY_REASSIGNMENT_BATCH = gql`
  mutation ApplyReassignmentBatch(
    $userIds: [String!]!
    $newCountryCode: String!
  ) {
    applyReassignmentBatch(userIds: $userIds, newCountryCode: $newCountryCode)
  }
`;
